import { queryOptions } from '@tanstack/react-query';

import { ANALYTICS_EVENTS } from '@/constants/analytics';
import { segmentClient } from '@/util/analytics';
import { fetchClient, isApiErrorV2 } from '@/util/fetchClient';

export async function getProviderV2(npi: string) {
  try {
    const { data } = await fetchClient.GET('/v2/providers/{npi}', {
      params: {
        path: {
          npi,
        },
      },
    });

    return data?.data;
  } catch (error) {
    throw error;
  }
}

export function getProviderV2QueryOptions(npi: string) {
  return queryOptions({
    queryKey: ['providers', npi],
    queryFn: () => getProviderV2(npi),
  });
}
